import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/i18n";

/** Compact language switcher used in the marketing header + footer.
 *  Deliberately styled minimally so it can drop into either surface without
 *  bringing its own opinionated palette. */
export function LanguageSwitcher({ variant = "compact" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const onChange = (e) => {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    // Persist explicitly — the detector caches it, but we also want any
    // early-loaded modules (like a header rendered before i18n hydrates)
    // to pick this up on next mount.
    try { localStorage.setItem("wsp.lang", lng); } catch { /* ignore */ }
  };
  return (
    <div
      data-testid="lang-switcher"
      style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <Globe size={variant === "compact" ? 14 : 16} strokeWidth={2} color="currentColor" />
      <select
        data-testid="lang-select"
        value={current}
        onChange={onChange}
        aria-label="Change language"
        style={{
          background: "transparent",
          color: "inherit",
          border: "none",
          fontSize: variant === "compact" ? 12 : 14,
          fontWeight: 600,
          cursor: "pointer",
          padding: "2px 4px",
          outline: "none",
        }}>
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} style={{ color: "#111" }}>
            {l.native}
          </option>
        ))}
      </select>
    </div>
  );
}
